import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Auth/updateApplication`, method: 'POST', body: values, token: token})
}